var map = {
	"./SFU/SFU教室_1.png": "t9e0",
	"./SFU/SFU教室_2.png": "lDsS",
	"./SFU/SFU教室_3.png": "l+Ue",
	"./SFU/SFU校区.png": "Xvqu",
	"./SFU/SFU老师_Alex.png": "yWku",
	"./SFU/SFU老师_Danny.png": "phcJ",
	"./SFU/SFU老师_Kid.png": "1NIl",
	"./SFU/SFU老师_Mark.png": "6nna",
	"./SFU/SFU老师_Paul.png": "FfOY",
	"./SFU/SFU老师_Stacy.png": "Z+L0",
	"./SFU/SFU老师_Steve.png": "7Ue5",
	"./SFU/SFU老师_Vicky.png": "cdBN",
	"./SFU/SFU老师_俊哥.png": "UxvQ",
	"./SFU/SFU老师_张博.png": "kxmH",
	"./SFU/SFU老师_沈思远.png": "29/C",
	"./SFU/SFU老师_皮哥.png": "VNKO",
	"./UBC/UBC教室_1.png": "ke/o",
	"./UBC/UBC教室_2.png": "mwtw",
	"./UBC/UBC教室_3.png": "iVYc",
	"./UBC/UBC校区.png": "gzRA",
	"./UBC/UBC老师_Alex.png": "khGY",
	"./UBC/UBC老师_Cathy.png": "7DfS",
	"./UBC/UBC老师_Holly.png": "tlde",
	"./UBC/UBC老师_Mark.png": "ePXl",
	"./UBC/UBC老师_Nemo.png": "zatt",
	"./UBC/UBC老师_俊哥.png": "qD5N",
	"./UBC/UBC老师_竺海华.png": "3IIJ",
	"./UBC/UBC老师_老杜.png": "kPB1",
	"./UTM/UTM教室_1.png": "n8vA",
	"./UTM/UTM教室_2.png": "2AtP",
	"./UTM/UTM教室_3.png": "22AG",
	"./UTM/UTM校区.png": "qHRr",
	"./UTM/UTM老师_Julie.png": "501G",
	"./UTM/UTM老师_Nick.png": "/Typ",
	"./UTM/UTM老师_丁然.png": "1jeH",
	"./UTM/UTM老师_宫春吉.png": "2wOW",
	"./UTM/UTM老师_张雪婷.png": "130y",
	"./UTM/UTM老师_火花.png": "NgTK",
	"./UTM/UTM老师_陈东尔.png": "JSZf",
	"./UTM/UTM老师_黑黑.png": "/E5z",
	"./UTSC/UTSC教室_1.png": "40on",
	"./UTSC/UTSC教室_2.png": "nSsX",
	"./UTSC/UTSC教室_3.png": "5gU9",
	"./UTSC/UTSC校区.png": "ASV/",
	"./UTSC/UTSC老师_Bobby.png": "lRl6",
	"./UTSC/UTSC老师_Erick.png": "cmig",
	"./UTSC/UTSC老师_May.png": "dlP0",
	"./UTSC/UTSC老师_Stephan.png": "eZ+e",
	"./UTSC/UTSC老师_Vincent.png": "dSWM",
	"./UTSC/UTSC老师_丁然.png": "5is7",
	"./UTSC/UTSC老师_文娜.png": "xz9A",
	"./UTSC/UTSC老师_火花.png": "s8DY",
	"./UTSG/UTSG教室_1.png": "qiRB",
	"./UTSG/UTSG教室_2.png": "BHbl",
	"./UTSG/UTSG教室_3.png": "fDir",
	"./UTSG/UTSG校区.png": "Qunw",
	"./UTSG/UTSG老师_Betty.png": "V02T",
	"./UTSG/UTSG老师_Dylan.png": "zuXr",
	"./UTSG/UTSG老师_Mark.png": "nXUF",
	"./UTSG/UTSG老师_Tony.png": "rZAn",
	"./UTSG/UTSG老师_Vincent.png": "gj5V",
	"./UTSG/UTSG老师_老杜.png": "Igox",
	"./UTSG/UTSG老师_老王.png": "oF3A",
	"./UTSG/UTSG老师_黑黑.png": "MOav",
	"./YORK/YORK教室 _1.png": "ZpdK",
	"./YORK/YORK教室 _2.png": "/e5T",
	"./YORK/YORK教室 _3.png": "c0m4",
	"./YORK/YORK校区.png": "IhG5",
	"./YORK/YORK老师_Edwin.png": "sCFq",
	"./YORK/YORK老师_Elaine.png": "iCgJ",
	"./YORK/YORK老师_Ling.png": "BP5R",
	"./YORK/YORK老师_子瑜.png": "tWtI",
	"./YORK/YORK老师_孙源.png": "6Evw",
	"./YORK/YORK老师_恩琪.png": "rk5L",
	"./YORK/YORK老师_文娜.png": "rz/O",
	"./YORK/YORK老师_轰轰.png": "hjkJ",
	"./landing_background_triangle.png": "MVUg",
	"./landing_logo.png": "y80G"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "V/tL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding ^\.\/.*\.png$
// module id = V/tL
// module chunks = 0